import React, { useState } from 'react';
import Card from '../common/Card';
import Input from '../common/Input';
import Button from '../common/Button';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import { toast } from 'react-hot-toast';

const UserProfile = () => {
  const { user } = useAuth();
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    first_name: user?.first_name || '',
    last_name: user?.last_name || '',
    email: user?.email || '',
    current_password: '',
    new_password: '',
    confirm_password: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.new_password && formData.new_password !== formData.confirm_password) {
      toast.error('Passwords do not match');
      return;
    }

    setSaving(true);
    try {
      // Create a profile update endpoint or use staff endpoint if it's the same
      await api.put(`/staff.php/${user.id}`, formData);
      toast.success('Profile updated successfully');
      // In a real scenario, you might want to refresh AuthContext here
    } catch (error) {
      toast.error(error.response?.data?.error || 'Failed to update profile');
    } finally {
      setSaving(false);
      setFormData(prev => ({
        ...prev,
        current_password: '',
        new_password: '',
        confirm_password: ''
      }));
    }
  };

  return (
    <div className="user-profile">
      <h3>My Profile</h3>
      <form onSubmit={handleSubmit} className="form-grid">
        <Input 
          label="First Name" 
          name="first_name" 
          value={formData.first_name} 
          onChange={handleChange} 
          required 
        />
        <Input 
          label="Last Name" 
          name="last_name" 
          value={formData.last_name} 
          onChange={handleChange} 
          required 
        />
        <Input 
          label="Email Address" 
          type="email"
          name="email" 
          value={formData.email} 
          onChange={handleChange} 
          required 
        />
        <div style={{ gridColumn: '1 / -1', marginTop: '1rem' }}>
          <h4>Change Password</h4>
          <p className="text-muted" style={{ marginBottom: '1rem', fontSize: '0.9rem' }}>
            Leave blank if you don't want to change your password.
          </p>
        </div>
        <Input 
          label="Current Password" 
          type="password"
          name="current_password" 
          value={formData.current_password} 
          onChange={handleChange} 
        />
        <Input 
          label="New Password" 
          type="password"
          name="new_password" 
          value={formData.new_password} 
          onChange={handleChange} 
        />
        <Input 
          label="Confirm New Password" 
          type="password"
          name="confirm_password" 
          value={formData.confirm_password} 
          onChange={handleChange} 
        />
        
        <div className="form-actions" style={{ gridColumn: '1 / -1', marginTop: '1rem' }}>
          <Button type="submit" variant="primary" loading={saving}>
            Save Profile
          </Button>
        </div>
      </form>
    </div>
  );
};

export default UserProfile;
